import React from 'react';
import { useTranslation } from 'react-i18next';
// import GeneralInfoItem from './GeneralInfoItem';
// import EsrrBadge from '../EsrrBadge';
// import PerformanceBadge from '../PerformanceBadge';
// import ImpactBadge from '../ImpactBadge';
// import RiskBadge from '../RiskBadge';
// import { Operation } from '../../../services/types/Operation';
// import { getInitials, isDraft } from '../../../shared/misc/utils';
// import AvatarGroup from './AvatarGroup';
// import MainContext from '../../App/MainProvider/context';
// import Role from '../../../types/role';
import { TypographyVariant as Variant } from '@mui/material/styles';
import { GrievanceItem } from '../../services/types/Grievance';
import ImpactBadge from '../Operations/ImpactBadge';
import UIKitRiskChip, { UIKitRiskVariant } from '../../shared/UIKITComponents/Chips/RiskChip';
import GeneralInfoItem from '../Operations/Operation/GeneralInfoItem';
import RiskChipWrapper from '../../shared/UIKITComponents/Chips/RiskChipWrapper';
import UIKitPerformanceChip from '../../shared/UIKITComponents/Chips/PerfonmanceChip';
import { customDateStr } from '../../shared/misc/utils';

interface Props {
  grievance: GrievanceItem;
}

const ESInformationContent: React.FC<Props> = ({ grievance }) => {
  const { t } = useTranslation();

  return (
    <div className="gi-items table-responsive">
      <GeneralInfoItem title={t('esic')}>
        {grievance.operationEsic && <ImpactBadge text={grievance.operationEsic} />}
      </GeneralInfoItem>
      <GeneralInfoItem title={t('dccrc')}>
        {grievance.operationDccrc && (
          <UIKitRiskChip variant={grievance.operationDccrc as UIKitRiskVariant} />
        )}
      </GeneralInfoItem>
      <GeneralInfoItem title={t('esrr')}>
        {grievance.operationEsrr && (
          <RiskChipWrapper value={grievance.operationEsrr as UIKitRiskVariant} />
        )}
      </GeneralInfoItem>
      <GeneralInfoItem title={t('spr')}>
        {grievance.operationSpr && (
          <UIKitPerformanceChip variant={grievance.operationSpr as Variant} />
        )}
      </GeneralInfoItem>
      <GeneralInfoItem title={t('sprDate')}>
        {customDateStr(grievance.operationSprDate)}
      </GeneralInfoItem>

      <GeneralInfoItem title={t('previousSPR')}>
        {grievance.previousSPR && (
          <UIKitPerformanceChip variant={grievance.previousSPR as Variant} />
        )}
      </GeneralInfoItem>
      <GeneralInfoItem title={t('previousSPRDate')}>
        {customDateStr(grievance.previousSPRDate)}
      </GeneralInfoItem>
    </div>
  );
};

export default ESInformationContent;
